import(/* webpackMode: "eager" */ "/codebuild/output/src2012239524/src/apps/wrap.gifts/node_modules/next/dist/client/link.js");
